module.exports = (__webpack_require__(24))(57);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/draft-js/lib/Draft.js from dll-reference lib_core
// module id = 87
// module chunks = 106